<template>
  <div :class="`app-header-extra ${isPortal ? 'portal' : 'no-portal'}`">
    <div v-if="isPortal" class="search__wrapper">
      <!--      <CAppSearchBar />-->
      <!-- <CAppSearchBar id="c-app-search-bar" /> -->
    </div>

    <div class="actions__wrapper">
      <!-- <template v-if="isPortal">
        <div class="nav-dropdown" v-if="!isBoss">
          <el-dropdown size="medium" trigger="click" @command="handleDropdownCommand">
            <div class="nav-action">
              <div class="icon__wrapper">
                <el-icon class="icon"><CircleCheckIcon /></el-icon>
              </div>
              <div class="label">审批</div>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item class="dropdown-link__item" command="task_list">审批流程</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <el-popover
          placement="bottom"
          trigger="click"
          :offset="7"
          popper-class="app-notify-popover"
          v-model:visible="notifyVisible"
          v-bind="notifyConfig?.popover"
        >
          <template #reference>
            <div class="nav-action">
              <div class="icon__wrapper">
                <el-icon class="icon"><BellIcon /></el-icon>
              </div>
              <div class="label">消息</div>
            </div>
          </template>
          <CAppNotifyContainer :visible="notifyVisible" @close="notifyVisible = false" />
        </el-popover>
      </template>

      <div v-if="isDownloads" class="nav-action download" @click="handleDownloadsClick">
        <div class="icon__wrapper">
          <el-icon class="icon"><ListIcon /></el-icon>
        </div>
        <div class="label">下载</div>
      </div> -->

      <div class="dropdown-con user">
        <el-dropdown class="link-item" size="medium" trigger="click" @command="handleDropdownCommand">
          <span class="dropdown-link">
            <span class="nickname text-ellipsis">{{ nickname }}</span>
            <el-icon class="dropdown-link__icon">
              <ArrowDownIcon />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <el-dropdown-item v-if="userPositions.length" class="dropdown-link__item" command="position">
                切换组织/岗位
              </el-dropdown-item> -->
              <!--         <el-dropdown-item v-if="isPortal || useOldVersion" class="dropdown-link__item" command="changeVersion">
                切回{{ useOldVersion ? '新' : '旧' }}版
              </el-dropdown-item>
            -->
              <el-dropdown-item class="dropdown-link__item" command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <template v-if="CAppMenuIntro">
      <CAppMenuIntro />
    </template>

    <!-- 用户切换组织/岗位提示 -->
    <el-dialog v-model="isShowPositionAlert" title="切换组织/岗位" width="550px">
      <div class="position-alert dialog-body">
        <div class="content">
          <div class="img01">
            <img :src="changePositionImg01" />
            <div class="text">账号信息</div>
          </div>
          <div class="img02">
            <img :src="changePositionImg02" />
            <div class="text">切换组织/岗位</div>
          </div>
        </div>
        <div class="tip">如需切换组织/岗位，您可在「账号信息-切换组织/岗位」中操作</div>
      </div>
      <template #footer>
        <span class="position-alert dialog-footer">
          <el-button type="primary" v-preventReclick @click="handleUserPositionConfirm">我知道了</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 用户切换组织/岗位对话框 -->
    <c-dialog ref="positionChooseDialogRef" v-bind="innerPositionChooseDialogAttrs"></c-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, useHostAppInstance } from '@zto/zpage'
import type { PageContext } from '@zto/zpage'
import { appUtil, ElementPlusIcons } from '@zto/zpage-ui-element'
import { saveAppAuthData } from '../../utils'

const { ArrowDown: ArrowDownIcon, List: ListIcon, Bell: BellIcon, CircleCheck: CircleCheckIcon } = ElementPlusIcons

const app = useHostAppInstance()

const { userStore } = app.stores
const basic = userStore.data?.basic
const isBoss = computed(() => {
  return basic.portalRoleCode === 'PORTAL_PC_BOSS'
})
const { authApi } = app.apis

const downloadsConfig = app.useAppConfig('header.downloads')
const notifyConfig = app.useAppConfig('header.notify')

const imageAssets = app.useAssets('images', {})
const { changePositionImg01, changePositionImg02 } = imageAssets

const userPositions = ref<any[]>([])
const isShowPositionAlert = ref(false)
const positionChooseDialogRef = ref<any>()
const notifyVisible = ref(false)

const useOldVersion: boolean = !!(localStorage.getItem('USEOLDVERSION') === 'TRUE')

const { CAppNotifyContainer, CAppSearchBar, CAppMenuIntro } = app.resolveComponents([
  'CAppNotifyContainer',
  'CAppSearchBar',
  'CAppMenuIntro'
])

const isPortal = computed(() => {
  return app.isPortal
})

const nickname = computed(() => {
  return userStore.nickname
})

const innerUserBasic = computed(() => {
  return userStore.data?.basic || {}
})

// portal选择
const innerPortalOptions = computed(() => {
  return (innerUserBasic.value?.portalIdentity || []).map(it => ({
    label: it.portalRoleName,
    value: it.portalRoleCode,
    useStatus: it.useStatus
  }))
})

// 是否显示门户选择
const isShowPortalSelect = computed(() => {
  return app.isPortal && innerPortalOptions.value.length > 1
})

const isDownloads = computed(() => {
  return !!(downloadsConfig && downloadsConfig !== false)
})

const innerPositionChooseDialogAttrs = computed(() => {
  return {
    title: '切换组织/岗位',
    width: '550px',
    formItems: positionChooseFormItems.value,
    onSubmit: positionChooseSubmitMethod
  }
})

const positionChooseFormItems = computed(() => {
  const isPortal = app.isPortal
  const userInfo = innerUserBasic.value

  const formItems: any[] = [
    {
      type: 'select',
      prop: 'positionKey',
      label: '组织/岗位',
      required: true,
      labelWidth: '120px',
      span: 24,
      dynamicAttrs: ({ data }: PageContext) => {
        let options = userPositions.value

        if (isPortal && data.portalRoleCode) {
          options = userPositions.value
            .filter(it => it.portalRoleCode === data.portalRoleCode)
            .map(it => ({
              ...it,
              value: [it.deptCode, it.positionCode].join()
            }))
        }

        return { options }
      }
    }
  ]

  if (isShowPortalSelect.value) {
    formItems.unshift({
      type: 'select',
      prop: 'portalRoleCode',
      options: innerPortalOptions.value,
      label: '门户',
      required: true,
      labelWidth: '120px',
      onChange: (model: any) => {
        model.positionKey = ''
      },
      span: 24
    })
  }
  return formItems
})

onMounted(async () => {
  await fetchUserPositions()

  if (!app.isPortal) {
    checkUserPositionAlert()
  }
})

// 加速将关闭不可见tab页，页面数据将被清空
async function handleSpeedupClick() {
  await app.ui.showMessageBox({
    boxType: 'confirm',
    type: 'warning',
    showCancelButton: true,
    message: '加速将关闭不可见tab页，页面数据将被清空，确认继续？'
  })

  await app.stores.pagesStore.pruneOthersVisited()
}

// 下拉菜单命令
function handleDropdownCommand(command: string) {
  switch (command) {
    case 'position':
      changeUserPosition()
      break
    case 'changeVersion':
      changeVersion()
      break
    case 'logout':
      logout()
      break
    case 'task_list':
      gotoTaskList()
      break
  }
}

function gotoTaskList() {
  app.router.goto('/portal/tasks')
}

async function logout() {
  app.logout()
  // await MessageBox.confirm('确定退出系统？', {
  //   title: '确认提示',
  //   confirmButtonText: '确定',
  //   cancelButtonText: '取消',
  //   type: 'warning'
  // }).then(() => {
  //   return app.logout()
  // })
}

async function changeVersion() {
  const flag = useOldVersion ? 'FALSE' : 'TRUE'

  const resp = await app.request({
    api: 'workbench.pc.switchVersions',
    params: { sysVersion: useOldVersion ? 'new' : 'old' }
  })

  if (resp === true) {
    localStorage.setItem('USEOLDVERSION', flag)
    setTimeout(() => {
      window.location.href = window.location.origin
    }, 500)
  }

  try {
    const userName = app?.stores?.userStore?.data?.basic?.mobile ?? ''
    const accountCode = app?.stores?.userStore?.data?.basic?.accountCode ?? ''
    app.api.reportTraceData(app, {
      event_code: 'action',
      event_data: { buttonLabel: `changeVersion-${userName}-${accountCode}` }
    })
  } catch (error) {
    console.log('error===', error)
  }
}

// 打开下载页
function handleDownloadsClick() {
  appUtil.openDownloadsDialog()
}

// 确认已读
async function handleUserPositionConfirm() {
  await authApi.confirmUserPositionRead()

  isShowPositionAlert.value = false
}

// 提交岗位选择
async function positionChooseSubmitMethod(payload: any) {
  const { positionKey, portalRoleCode } = payload || {}

  if (!positionKey) return
  const position = userPositions.value.find(it => it.value === positionKey) // 获取岗位信息

  if (!position) return

  if (app.isPortal && !portalRoleCode) return

  await authApi.changeUserPosition({
    deptCode: position.deptCode,
    positionCode: position.positionCode
  })

  if (app.isPortal) {
    await app.request({
      api: 'workbench.pc.switchPortalIdentity',
      params: { portalRoleCode }
    })

    // 切换cookie角色
    saveAppAuthData({
      deptCode: position.deptCode,
      positionCode: position.positionCode,
      portalRoleCode
    })
  }

  setTimeout(() => {
    window.location.href = window.location.origin
  }, 200)
}

// 切换用户组织岗位
function changeUserPosition() {
  const userBasic = innerUserBasic.value
  if (!userBasic) return

  const portalRoleCode = userBasic.portalRoleCode
  const positionKey = [userBasic.deptCode, userBasic.positionCode].join()

  positionChooseDialogRef.value.show({
    positionKey,
    portalRoleCode: userBasic.portalRoleCode
  })
}

/** 检查用户是否已选择岗位 */
function checkUserPositionAlert() {
  const userBasic = innerUserBasic.value
  if (!userBasic) return

  // 当用户拥有多个岗位，且没有选择部门，且没有设置已读，跳出提醒
  if (userPositions.value?.length > 1 && !userBasic.chooseDeptPosition && !userBasic.readDeptPosition) {
    isShowPositionAlert.value = true
  }
}

/** 获取用户岗位列表 */
async function fetchUserPositions() {
  let positionsData: any[] = []

  if (app.isPortal) {
    positionsData = innerUserBasic.value.deptPosition
  } else {
    positionsData = await authApi.getUserPositions()
  }

  userPositions.value = (positionsData || []).map((it: any) => {
    return {
      ...it,
      value: [it.deptCode, it.positionCode].join(),
      label: `${it.deptName || ''} - ${it.positionName || ''}`
    }
  })
}
</script>

<style lang="scss" scoped>
.app-header-extra {
  display: flex;
  justify-content: flex-end;

  &.no-portal {
    padding-right: 0;

    .actions__wrapper {
      width: 100%;
      justify-content: flex-end;

      .nav-action {
        &.download {
          flex-direction: row;

          & > .label {
            padding-top: 2px;
            padding-left: 2px;
          }
        }
      }

      .nickname {
        max-width: 200px;
        display: inline-block;
      }

      .dropdown-con.user {
        min-width: 70px;
      }
    }
  }
}

.search__wrapper {
  padding-right: 10px;
}

.nav-action {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
  cursor: pointer;
  text-align: center;
  line-height: 12px;

  color: white;

  .label {
    padding-top: 5px;
  }
}

.position-alert {
  &.dialog-body {
    & > .content {
      display: flex;

      & > .img01 img {
        width: 200px;
      }

      & > .img02 img {
        width: 300px;
      }

      .text {
        text-align: center;
        line-height: 30px;
      }
    }

    & > .tip {
      padding: 10px 20px;
    }
  }

  &.dialog-footer {
    padding: 10px 20px;
  }
}
</style>
